import { useState, useEffect } from 'react'

export function useReducedMotion() {
  // Initialize with the actual value if window is defined, to avoid the effect setting it right away
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia('(prefers-reduced-m: reduce)').matches
    }
    return false
  })

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mediaQuery = window.matchMedia('(prefers-reduced-m: reduce)')

    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [])

  return matches
}
